import React from 'react'
import IconSocialMediaFacebook from './components/IconSocialMediaFacebook/IconSocialMediaFacebook';
import IconSocialMediaLinkedin from './components/IconSocialMediaLinkedin/IconSocialMediaLinkedin';
import IconSocialMediaYoutube from './components/IconSocialMediaYoutube/IconSocialMediaYoutube';
import IconSocialMediaTwitter from './components/IconSocialMediaTwitter/IconSocialMediaTwitter';
import IconSocialMediaInstagram from './components/IconSocialMediaInstagram/IconSocialMediaInstagram';

import DummyListingImage from '../../assets/Website Profile Placeholder Banners-01.jpg'

import css from './PartnerProfileHeaderBanner.module.css'

const MAIN_BUCKET_NAME = process.env.REACT_APP_GCS_MAIN_BUCKET_NAME;
const GCS_URL = process.env.REACT_APP_GCS_URL;

const WebIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="none" d="M11 1C13.5013 3.73835 14.9228 7.29203 15 11C14.9228 14.708 13.5013 18.2616 11 21M11 1C8.49872 3.73835 7.07725 7.29203 7 11C7.07725 14.708 8.49872 18.2616 11 21M11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21M11 1C16.5228 1 21 5.47715 21 11C21 16.5228 16.5228 21 11 21M1.50002 8H20.5M1.5 14H20.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

const getImageUrl = (fileId) => `${GCS_URL}/${MAIN_BUCKET_NAME}/${fileId}`;

const PartnerProfileHeaderBanner = ({
  companyLegalName,
  companyDescription,
  websiteUrl,
  bannerUrl,
  socials,
}) => {

  return (
    <>
      <div className={css.container}>
        <div className={css.profilePageMainBannerWrapper}>
          {bannerUrl ? (
            <img
              src={getImageUrl(bannerUrl)}
              alt="Profile Header Banner"
            /> ) : (
              <div className={css.banner}>
                <img src={DummyListingImage} alt="banner" />
              </div>
            )}
          <div className={css.bannerInfo}>
            <h2>{companyLegalName}</h2>
            <p>{companyDescription}</p>
          </div>
          <div className={css.socialProfiles}>
            <div>
              {websiteUrl ? (
                <a href={websiteUrl} target='_blank'>
                  <WebIcon />
                </a>
              ) : null}
            </div>
            <div>
              {socials.map(({ name, url }, i) => {

                let icon = null;

                switch(name.toLowerCase()){
                  case 'facebook':
                    icon = <IconSocialMediaFacebook />
                    break;

                  case 'x':
                    icon = <IconSocialMediaTwitter />
                    break;

                  case 'instagram':
                    icon = <IconSocialMediaInstagram />
                    break;

                  case 'youtube':
                    icon = <IconSocialMediaYoutube />
                    break;

                  case 'linkedin':
                    icon = <IconSocialMediaLinkedin />
                    break;
                }

                return (
                  <a href={url} target='_blank' key={name + url + i} >
                    {icon}
                  </a>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PartnerProfileHeaderBanner
